import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [TranslateModule, ButtonModule],
  templateUrl: './cookie-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit {
  showBanner = false;
  private readonly COOKIE_CONSENT_KEY = 'cookie-consent-accepted';

  ngOnInit(): void {
    this.checkCookieConsent();
  }

  private checkCookieConsent(): void {
    const consent = localStorage.getItem(this.COOKIE_CONSENT_KEY);
    this.showBanner = !consent;
  }

  acceptCookies(): void {
    localStorage.setItem(this.COOKIE_CONSENT_KEY, 'true');
    this.showBanner = false;
  }

  declineCookies(): void {
    localStorage.setItem(this.COOKIE_CONSENT_KEY, 'false');
    this.showBanner = false;
  }
}